const getters = {
  networkState: state => state.app.networkState,
  orderDTO: state => state.app.orderDTO
}
export default getters
